import Page from "../Common/Page";
import React from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Divider,
  Space,
  Layout,
  message,
} from "antd";
import { LockOutlined } from "@ant-design/icons";
import { Messages } from "../Common/ValidateMessages";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import { Content } from "antd/lib/layout/layout";
import { NavigateFunction, Params } from "react-router-dom";
import withRouterDom from "../Common/WithReactRouterDom";
import "../Style/Password.css";

type FormData = {
  password: string;
};
interface Props {
  navigation: NavigateFunction;
  params: Readonly<Params<string>>;
  location: any;
}
interface UserGetRequestBean {
  userId: string;
}
interface UserGetResponseBean {
  userId: string;
  defaultPw: string;
  userAccount: string;
  sei: string;
  mei: string;
}
class ResetPassword extends React.Component<Props> {
  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;
  static contextType = AuthContext;

  state = {
    userId: "",
    defaultPw: "",
    userAccount: undefined,
    sei: undefined,
    mei: undefined,
  };

  constructor(props: any) {
    super(props);
    this._page = React.createRef<Page>();
    this._form = React.createRef();
  }

  componentDidMount = async () => {
    const { params } = this.props;
    if (params.userId !== undefined) {
      try {
        this._page.current?.setState({ isPageLoading: true });

        const postData: UserGetRequestBean = {
          userId: params.userId,
        };
        const result = await http<UserGetResponseBean, UserGetRequestBean>({
          path: "/User/resetPwInit",
          method: "post",
          body: postData,
          accessToken: this.context.accessToken,
        });
        if (result.ok) {
          this.setState({
            userId: result.body?.userId,
            defaultPw: result.body?.defaultPw,
            userAccount: result.body?.userAccount,
            sei: result.body?.sei,
            mei: result.body?.mei,
          });
          this._form.current.setFieldsValue({
            password: this.state.defaultPw,
            confirm: this.state.defaultPw,
            userAccount: result.body?.userAccount,
            name: result.body?.sei! + result.body?.mei!,
          });
        } else {
          message.error(Messages["ERR-020"]);
        }
        this._page.current?.setState({ isPageLoading: false });
      } catch (error) {
        console.log(error);
        message.error(Messages["ERR-020"]);
        this._page.current?.setState({ isPageLoading: false });
      }
    } else {
      message.error(Messages["ERR-020"]);
    }
  };

  backToList = () => {
    const { location, navigation } = this.props;
    if (location.state) {
      navigation("/UserList", { state: location.state });
    } else {
      navigation("/UserList");
    }
  };

  submitForm = async (data: FormData) => {
    this._page.current?.setState({ isPageLoading: true });

    try {
      const result = await http<
        undefined,
        {
          Password: string;
          Target: string;
        }
      >({
        path: "/User/resetPassword",
        method: "post",
        body: {
          Target: this.state.userId,
          Password: data.password,
        },
        accessToken: this.context.accessToken,
        noResponsebody: true,
      });

      this._page.current?.setState({ isPageLoading: false });
      if (result.ok) {
        message.success(Messages["MSG-015"]);
        this.backToList();
      } else {
        /* APIエラー 判定 */
        // パスワードの変更に失敗しました
        if (result.statusCode === 400) {
          message.error(Messages["ERR-038"]);
        } else {
          message.error(Messages["ERR-039"]);
        }
      }
    } catch (error) {
      console.log(error);
      message.error(Messages["ERR-039"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onFormValueChange = () => {};

  // validator
  validatorIsPassword = async (_: any, value: string): Promise<void> => {
    const pattern = {
      password: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[!-~]{8,30}$/,
    };
    if (
      value !== undefined &&
      value != null &&
      value.length <= 30 &&
      !value.match(pattern.password)
    ) {
      // TODO メッセージ
      return Promise.reject(new Error(Messages["ERR-038"]));
    }
    return Promise.resolve();
  };

  render() {
    return (
      <>
        <Page title="パスワードリセット" ref={this._page}>
          <Layout style={{ padding: "0 24px 24px" }}>
            <Content
              className="site-layout-background"
              style={{
                padding: 24,
                margin: 0,
                minHeight: 280,
              }}
            >
              <Row>
                <Col span={10}>
                  下記アカウントのパスワードをリセットします。
                  <br />
                  <br />
                </Col>
              </Row>
              <Row>
                <Col span={10}>
                  <Form
                    name="password"
                    layout="vertical"
                    onFinish={this.submitForm}
                    onValuesChange={this.onFormValueChange}
                    autoComplete="off"
                    className="login-form"
                    validateTrigger={["onBlur"]}
                    ref={this._form}
                  >
                    <Form.Item label="アカウント" name="userAccount">
                      <Input
                        style={{ width: 250 }}
                        maxLength={30}
                        disabled={true}
                      />
                    </Form.Item>
                    <Form.Item label="姓名" name="name">
                      <Input
                        style={{ width: 250 }}
                        maxLength={30}
                        disabled={true}
                      />
                    </Form.Item>
                    <Form.Item
                      name="password"
                      label="パスワード"
                      rules={[
                        { required: true },
                        { max: 30 },
                        { min: 8 },
                        { validator: this.validatorIsPassword },
                      ]}
                    >
                      <Input.Password
                        prefix={
                          <LockOutlined className="site-form-item-icon" />
                        }
                        placeholder="パスワード"
                        maxLength={30}
                      />
                    </Form.Item>
                    <Form.Item
                      name="confirm"
                      label="パスワード確認"
                      dependencies={["password"]}
                      rules={[
                        { required: true },
                        // { max: 30 },
                        // { min: 8 },
                        // { validator: this.validatorIsPassword },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value || getFieldValue("password") === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error(Messages["ERR-014"])
                            );
                          },
                        }),
                      ]}
                    >
                      <Input.Password
                        prefix={
                          <LockOutlined className="site-form-item-icon" />
                        }
                        placeholder="パスワード"
                        maxLength={30}
                      />
                    </Form.Item>
                    <br />
                    <Row style={{ marginTop: "10px", marginLeft: "10px" }}>
                      <Col span={10}>
                        <Form.Item>
                          <Space
                            split={<Divider type="vertical" />}
                            size={"large"}
                          >
                            <Button
                              type="primary"
                              htmlType="submit"
                              className="login-form-button"
                            >
                              パスワードリセット
                            </Button>
                          </Space>
                        </Form.Item>
                      </Col>
                      <Col span={5}>
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={this.backToList}
                        >
                          戻る
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
                <Col span={8}>
                  <Row>
                    <Col>
                      <div
                        id={"PolicyClolor"}
                        style={{ padding: "0 24px 24px" }}
                      >
                        <h3 id={"PolicyClolor"}>パスワードポリシー</h3>
                        <ul style={{ padding: "0 24px 24px" }}>
                          <li>英字：最低大文字1文字以上を含む</li>
                          <li>英字：最低小文字1文字以上を含む</li>
                          <li>数字：最低1文字を含む</li>
                          <li>長さ：最低8文字以上30文字まで</li>
                          <li>文字種：半角文字</li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Content>
          </Layout>
        </Page>
      </>
    );
  }
}
export default withRouterDom(ResetPassword);
